import { magicNumbers } from 'utils';
import { newsInitialState } from './newsInitialState';
import { instagramInitialState } from './instagramInitialState';
import { telegramInitialState } from './telegramInitialState';
import { twitterInitialState } from './twitterInitialState';
import { virastyInitialState } from './virastyInitialState';
import { newspaperInitialState } from './newspaperInitialState';
import { nativePlatformsInitialState } from './nativePlatformsInitialState';
import { linkedinInitialState } from './linkedinInitialState';
import { instagramCommentInitialState } from './instaramCommentinitialState';
import { kioskInitialState } from './kioskInitialState';

export const autoBulletinFiltersInitialState = {
  news: newsInitialState,
  instagram: instagramInitialState,
  instagramComment: instagramCommentInitialState,
  telegram: telegramInitialState,
  twitter: twitterInitialState,
  virasty: virastyInitialState,
  newspaper: newspaperInitialState,
  kiosk: kioskInitialState,
  nativePlatforms: nativePlatformsInitialState,
  linkedin: linkedinInitialState,
};

export const autoBulletinInitialState = {
  autoBulletins: {
    data: [],
    loading: false,
    error: null,
  },
  currentBulletin: {
    step: 0,
    open: false,
    platforms: [],
    filters: {
      global: {
        advertisement: false,
        source: false,
      },
    },
    summery: false,
    summeryContentCount: 0,
    active: false,
    hash: null,
    id: null,
    title: '',
    suffixType: 'date',
    days: [],
    creationHour: magicNumbers.SMART_BULLETIN_DEFAULT_HOUR,
    timeType: 1,
    timeCount: '',
    count: '',
    query: null,
    highlightWords: null,
    autoContentSubmission: true,
    selectedSort: {
      news: 'time',
      instagram: 'time',
      instagramComment: 'time',
      telegram: 'time',
      twitter: 'time',
      virasty: 'time',
      newspaper: 'time',
      nativePlatforms: 'time',
      instagramStories: 'time',
      linkedin: 'time',
    },
    primaryColor: '',
    secondaryColor: '',
    logo: '',
    headerType: '',
    enableLogo: false,
  },
  saveAutoBulletinRequest: {
    loading: false,
    error: null,
  },
  deleteAutoBulletinRequest: {
    loading: false,
    error: null,
  },
  toggleActivationAutoBulletinRequest: {
    loading: false,
    error: null,
  },
  shareHashAutoBulletinRequest: {
    loading: false,
    error: null,
  },
  deleteAutoBulletinContent: {
    loading: false,
    error: null,
  },
  pinAutoBulletinContents: {
    loading: false,
    error: null,
  },
  fetchAutoBulletinByHash: {
    error: null,
  },
  archives: {
    data: [],
    loading: false,
    error: null,
  },
  contents: {
    loading: false,
    error: null,
    news: {
      data: [],
      total: 0,
    },
    instagramStories: {
      data: [],
      total: 0,
    },
    instagram: {
      data: [],
      total: 0,
    },
    instagramComment: {
      data: [],
      total: 0,
    },
    telegram: {
      data: [],
      total: 0,
    },
    twitter: {
      data: [],
      total: 0,
    },
    virasty: {
      data: [],
      total: 0,
    },
    newspaper: {
      data: [],
      total: 0,
    },
    kiosk: {
      data: [],
      total: 0,
      loading: false,
      error: null,
    },
    nativePlatforms: {
      data: [],
      total: 0,
    },
    linkedin: {
      data: [],
      total: 0,
    },
  },
  selectedContents: [],
  pinnedContents: {},
  selectedArchive: {},
  currentAutoBulletin: {},
  isDetailsOpen: false,
  selectedContent: {
    id: undefined,
    index: undefined,
  },
  selectedPreviewTab: '',
  filters: autoBulletinFiltersInitialState,
  summary: null,
  uploadBulletinImage: {
    loading: false,
    error: null,
    data: '',
  },
};
